// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1292":"5c1c6799","6690":"193cd09d"}[chunkId] + ".chunk.css";
};